module.exports={select:"Vybrat",selected:"Vybráno"};